import { reduce } from 'lodash';
import {
  GET_DATA_SETS_SUCCESS,
  GET_AVAILABLE_DATASETS_SUCCESS,
  GET_AVAILABLE_DATASET_SUCCESS,
  GET_PUBLIC_DATASETS_SUCCESS,
  GET_PUBLIC_DATASET_SUCCESS,
  GET_DATA_SOURCES_SUCCESS,
  UPDATE_DATA_SET_RECIPE_SUCCESS,
  UPDATE_SCHEMA_ANNOTATIONS_SUCCESS,
  GET_DATA_SET_SUCCESS,
  ADD_DATASET_SUCCESS,
  LOGOUT_COMPLETE,
  GET_DATA_SAMPLES_SUCCESS,
  UPDATE_DATA_SAMPLES_SUCCESS,
  GET_DOMAIN_ITEMS_SUCCESS,
  GET_REQUEST_DATASET_SUCCESS,
  GET_DOMAIN_ITEM_SUCCESS,
} from '../../constants/actionTypes';
import DataSchemaProcessor from '../../lib/DataSchemaProcessor';
import { isJsonSchema } from '../../lib/SchemaValidationUtils';

import pick from 'lodash/pick';
import forOwn from 'lodash/forOwn';
import merge from 'lodash/merge';
import has from 'lodash/has';
import pickBy from 'lodash/pickBy';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_DATA_SETS_SUCCESS:
    case GET_AVAILABLE_DATASETS_SUCCESS:
    case GET_PUBLIC_DATASETS_SUCCESS:
    case GET_DATA_SOURCES_SUCCESS: {
      let { dataSets } = action.entities;
      // let dataSetIds = action.result;
      let newDataSetSchemas = getAllFlatSchemas(state, dataSets);
      return merge({ type: action.type }, state, newDataSetSchemas);
    }

    case ADD_DATASET_SUCCESS:
    case GET_DATA_SET_SUCCESS:
    case GET_AVAILABLE_DATASET_SUCCESS:
    case GET_PUBLIC_DATASET_SUCCESS: {
      let {
        entities: { dataSets },
        result,
      } = action;
      let newDataSetSchema = getFlatSchemaForDataSet(state, dataSets[result]);
      return { ...state, [result]: newDataSetSchema };
    }

    case GET_REQUEST_DATASET_SUCCESS:
    case GET_DOMAIN_ITEM_SUCCESS: {
      let {
        entities: { marketplaceItems },
        result,
      } = action;
      let newDataSetSchema = getFlatSchemaForDataSet(state, marketplaceItems[result]);
      return { ...state, [result]: newDataSetSchema };
    }

    case GET_DOMAIN_ITEMS_SUCCESS: {
      let { marketplaceItems } = action.entities;
      let newDataSetSchemas = getAllFlatSchemas(state, marketplaceItems);
      return merge({ type: action.type }, state, newDataSetSchemas);
    }

    case GET_DATA_SAMPLES_SUCCESS:
    case UPDATE_DATA_SAMPLES_SUCCESS: {
      let {
        requestInfo: { id },
        result,
      } = action;
      let newDataSetSchema = getFlatSchemaFromSamples(state, id, result);
      return { ...state, [id]: newDataSetSchema };
    }

    case UPDATE_DATA_SET_RECIPE_SUCCESS:
    case UPDATE_SCHEMA_ANNOTATIONS_SUCCESS: {
      let {
        entities: { dataSets },
        requestInfo: { dataSetId },
      } = action;
      let newDataSetSchema = getFlatSchemaForDataSet(state, dataSets[dataSetId]);
      return { ...state, [dataSetId]: newDataSetSchema };
    }

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
}

function getAllFlatSchemas(state, dataSets, dataSetIds = null) {
  let dataSetsToProcess = dataSetIds ? pick(dataSets, dataSetIds) : dataSets;

  //Flattening schema is an expensive process. Let's make sure we only flatten schemas for Nexsets that have been updated since last flatten. Ideally we should even check if there was a check in Nexset schema and not just any update.

  let schemasToUpdate = pickBy(dataSetsToProcess, function (s) {
    return !has(state, [s.id]) || state[s.id].lastUpdated !== s.updated_at;
  });

  let dataSetSchemas = {};
  forOwn(schemasToUpdate, function (ds, id) {
    // let thisSchema = {};
    //
    // thisSchema.lastUpdated = moment(ds.updated_at).valueOf();
    //
    // thisSchema.in = (ds.resource_type === 'SOURCE') &&  has(ds,'source_schema') && has(ds.source_schema,'properties') ? getFlatSchemaFromNested(ds.source_schema) : null;
    //
    // thisSchema.fromDataSet = has(ds, 'parent_data_set') && has(ds.parent_data_set, 'id') ? ds.parent_data_set.id : null;
    //
    // thisSchema.out = has(ds,'output_schema') && has(ds.output_schema,'properties') ? getFlatSchemaFromNested(ds.output_schema) : null;
    //
    // thisSchema.transform = has(ds, 'transform') ? ds.transform : null;

    dataSetSchemas[id] = getFlatSchemaForDataSet(state, ds);
  });
  return dataSetSchemas;
}

function getFlatSchemaForDataSet(state, ds) {
  let thisSchema = {
    ...state[ds.id],
    lastUpdated: moment(ds.updated_at).valueOf(),
  };

  if (
    ds.resource_type === 'SOURCE' &&
    has(ds, 'source_schema') &&
    has(ds.source_schema, 'properties')
  ) {
    thisSchema.in = getFlatSchemaFromNested(ds.source_schema);
  } else {
    thisSchema.in = null;
  }

  thisSchema.fromDataSet =
    has(ds, 'parent_data_sets') &&
    !isEmpty(ds.parent_data_sets) &&
    has(ds.parent_data_sets[0], 'id')
      ? ds.parent_data_sets[0].id
      : null;

  if (has(ds, 'output_schema') && has(ds.output_schema, 'properties')) {
    thisSchema.out = getFlatSchemaFromNested(ds.output_schema);
  } else {
    thisSchema.out = null;
  }

  if (has(ds, 'semantic_schema') && has(ds?.semantic_schema?.schema_classification, 'properties')) {
    const schemaClassification = ds?.semantic_schema?.schema_classification?.properties;

    // Check if this is a proper JSON Schema format
    if (isJsonSchema(schemaClassification)) {
      // JSON Schema format: use properties directly
      thisSchema.semanticSchema = schemaClassification.properties;
    } else {
      // Legacy format: use the object directly
      thisSchema.semanticSchema = schemaClassification;
    }
  }

  return thisSchema;
}

function getFlatSchemaFromNested(dataSetSchema) {
  const flatSchema = DataSchemaProcessor.flattenSchema(
    dataSetSchema.properties,
    dataSetSchema.required,
    0,
  );

  return flatSchema;
}

function getFlatSchemaFromSamples(state, id, samples) {
  let metaFlatSchema = DataSchemaProcessor.getSchemaFromSamples(
    map(samples, 'nexlaMetaData'),
    true,
  );

  return {
    ...state[id],
    outMetaData: metaFlatSchema,
  };
}

function saveDomainItemsSchema(state, action) {
  let { result } = action;

  if (Object.keys(result).length === 0) {
    return state;
  }

  let newDataSetSchemas = {};
  reduce(result, (result, v) => {
    newDataSetSchemas[v.id] = getFlatSchemaForDataSet(state, v.id);
    return newDataSetSchemas;
  });

  return {
    ...state,
    ...newDataSetSchemas,
  };
}
